import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetWard(id: string | undefined) {
  return useQuery(queries.locations.getWardById(id || ''))
}
